import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-investor-history',
  templateUrl: './investor-history.component.html',
  styleUrls: ['./investor-history.component.css']
})
export class InvestorHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/history/investor-history/investor-history.component.ts